<script setup lang="ts">
import DefaultInput from '../components/DefaultInput.vue';
import DefaultSelect from '../components/DefaultSelect.vue';
import PostalCode from '../components/PostalCode.vue';

import { useCurrentClient } from '../composables/useCurrentClient';

import { PROVINCES } from '../utils/constants';

const { currentClient } = useCurrentClient();
</script>

<template>
  <div v-if="currentClient" class="mb-6">
    <div class="mb-4 flex justify-between">
      <h2 class="font-bold text-gray-900">Dane osobowe</h2>
    </div>

    <div class="grid grid-cols-12 gap-6">
      <DefaultInput class="col-span-6" :model-value="currentClient.first_name" disabled>
        Imię*
      </DefaultInput>

      <DefaultInput class="col-span-6" :model-value="currentClient.last_name" disabled>
        Nazwisko*
      </DefaultInput>

      <DefaultInput class="col-span-6" :model-value="currentClient.email" disabled>
        E-mail*
      </DefaultInput>

      <DefaultInput class="col-span-6" :model-value="currentClient.phone" disabled>
        Numer telefonu*
      </DefaultInput>

      <DefaultInput class="col-span-8" :model-value="currentClient.street" disabled>
        Adres*
      </DefaultInput>

      <DefaultInput class="col-span-2" :model-value="currentClient.house_number" disabled>
        Numer domu*
      </DefaultInput>

      <DefaultInput
        class="col-span-2"
        :model-value="currentClient.apartment_number"
        disabled
      >
        Numer mieszkania
      </DefaultInput>

      <DefaultSelect
        class="col-span-2"
        :model-value="currentClient.province"
        :options="PROVINCES"
        placeholder="Wybierz"
        filter
        disabled
      >
        Województwo*
      </DefaultSelect>

      <DefaultInput class="col-span-8" :model-value="currentClient.city" disabled>
        Miejscowość*
      </DefaultInput>

      <PostalCode class="col-span-2" :model-value="currentClient.postal_code" disabled>
        Kod pocztowy*
      </PostalCode>
    </div>
  </div>
</template>
